export const FIELD_PRIORITY = [
  "type/DateTime",
  "type/DateTimeWithTZ",
  "type/DateTimeWithLocalTZ",
  "type/DateTimeWithZoneOffset",
  "type/DateTimeWithZoneID",
  "list",
  "type/Integer",
  "type/Float",
  "type/Boolean",
  "type/Category",
  "type/PK",
  "type/FK",
  "type/Text",
];
